import React from 'react'
import { ReactComponent as OpenExternalIcon } from 'assets/icons/open-external.svg'
import { ReactComponent as ClockIcon } from 'assets/icons/clock.svg'
import { ReactComponent as MessageIcon } from 'assets/icons/message.svg'
import s from './EssayReviewSlideCard.module.scss'

const EssayReviewSlideCard = ({
	typeLabel = '',
	title = 'Essay',
	statusLabel = '',
	statusTone = 'draft',
	dateLabel = '',
	hasNew = false,
	unreadFeedbackCount = 0,
	onOpen,
	openButtonLabel = 'Open Essay',
	openButtonClassName = '',
	slideVariant = '',
	className = '',
}) => {
	const unreadCount = Number(unreadFeedbackCount) || 0
	const tone = statusTone || 'draft'
	const isBigButton = openButtonClassName === 'big'

	return (
		<article
			className={`${s.slide} ${slideVariant ? s[slideVariant] : ''} ${className}`.trim()}
		>
			<div className={s.slideHead}>
				<div className={s.slideMeta}>
					{typeLabel ? <span className={s.type}>{typeLabel}</span> : null}
					<div className={s.updatedRow}>
						<span className={s.updated}>
							<span className={s.updated__icon} aria-hidden="true">
								<ClockIcon />
							</span>
							<span className={s.updated__label}>{dateLabel}</span>
						</span>
						{unreadCount > 0 ? (
							<span className={s.feedbackPill}>
								<span className={s.feedbackPill__icon}>
									<MessageIcon />
								</span>
								<span className={s.feedbackPill__label}>+{unreadCount}</span>
							</span>
						) : null}
					</div>
				</div>

				<div className={s.statusStack}>
					{hasNew ? <span className={s.newPill}>NEW</span> : null}
					<span className={`${s.statusPill} ${s[tone]}`}>{statusLabel}</span>
				</div>
			</div>

			<h5 className={s.essayTitle}>{title}</h5>

			<button
				type="button"
				className={`${s.openBtn} ${isBigButton ? s.big : ''}`.trim()}
				onClick={e => {
					e.stopPropagation()
					onOpen?.()
				}}
			>
				<span className={s.openBtnLabel}>{openButtonLabel}</span>
				{!isBigButton ? (
					<span className={s.icon}>
						<OpenExternalIcon />
					</span>
				) : null}
			</button>
		</article>
	)
}

export default EssayReviewSlideCard
